const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_home/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_home/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { alternatesToLinks, buildCanonicalAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { getRootLoaderData } from "@/types/intl";
import { HOME_TRENDING_OFFER_LIMIT } from "./home-query";
export const Route = createFileRoute("/_home/")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match,
    loaderData
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "home"
    });
    const alts = buildCanonicalAlternates("/");
    const trending = loaderData?.trending;
    const trendingOffers = trending?.vinyl.length ? trending.vinyl : trending?.cd ?? [];
    const jsonLd = trendingOffers.length ? (await import("@/utils/jsonld")).buildHomepageItemListJsonLd(trendingOffers.slice(0, HOME_TRENDING_OFFER_LIMIT).map(offer => ({
      name: offer.album.title,
      releaseId: offer.album.releaseId,
      imageUrl: offer.album.imageUrl
    }))) : null;
    return {
      meta: await buildPagePreviewMetaTags({
        title: t("metadataTitle"),
        description: t("metadataDescription"),
        canonicalUrl: alts.canonical,
        socialTitle: t("headline"),
        imageUrl: trendingOffers[0]?.album.imageUrl
      }, {
        openGraph: {
          type: "website",
          image: {
            width: "1200",
            height: "630",
            alt: t("ogAlt")
          }
        },
        twitter: {}
      }, {
        locale
      }),
      links: alternatesToLinks(alts),
      scripts: jsonLd ? [{
        type: "application/ld+json",
        children: JSON.stringify(jsonLd)
      }] : undefined
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});